export default "__VITE_ASSET__TyPHgKsr__"